/**
 * @module store/marathons/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив стартов (текущую "страницу")
 *
 * @returns {array}
 */
const marathons = state => state.marathons;


/**
 * Getter: Возвращает общее число стартов
 *
 * @returns {number}
 */
const marathonsCount = state => state.total;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент страница со стартами
 *
 * @returns {boolean}
 */
const isMarathonsLoading = state => state.isLoading;


export default {
  marathons,
  marathonsCount,
  isMarathonsLoading,
};
